import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { FrBirthplace } from './FranceFields/BirthPlace'
import { FrBirthname } from './FranceFields/Birthname'
import { FrCountryOfBirth } from './FranceFields/CountryOfBirth'

const General = () => {
  return (
    <>
      <Box paddingTop="s24" paddingBottom="s8">
        <Text.Normal size="300" color="grey800" weight="medium">
          {i18n.t(
            'processes.process_settings.wizard.tasks.types.request_general_information.preview.general.title'
          )}
        </Text.Normal>
      </Box>

      <Box padding="s24" gap="s24" background="grey200" borderRadius={{ all: 'abs008' }}>
        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.first_name')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Box padding="s4"></Box>
          </Box>
        </Box>

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.last_name')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Box padding="s4"></Box>
          </Box>
        </Box>

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.preferred_name')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Box padding="s4"></Box>
          </Box>
        </Box>

        <FrBirthname />

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.birthday')}
          </Text.Normal>
          <Box
            background="grey000White"
            paddingY="s8"
            paddingX="s12"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey800">10/05/1990</Text.Normal>
            <Icon.Small icon="caret-down" color="grey800" />
          </Box>
        </Box>

        <FrCountryOfBirth />

        <FrBirthplace />

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.gender')}
          </Text.Normal>
          <Box
            background="grey000White"
            paddingY="s8"
            paddingX="s12"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey600">{i18n.t('common.select_default')}</Text.Normal>
            <Icon.Small icon="caret-down" color="grey800" />
          </Box>
        </Box>

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.nationality')}
          </Text.Normal>
          <Box
            background="grey000White"
            paddingY="s8"
            paddingX="s12"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey600">{i18n.t('common.select_default')}</Text.Normal>
            <Icon.Small icon="caret-down" color="grey800" />
          </Box>
        </Box>

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.phone_number')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Box padding="s4"></Box>
          </Box>
        </Box>

        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.communications_email.label')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Box padding="s4"></Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default General
